var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildSequenceStrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.7475H16.5M1.5 2.7475H3.75M14.25 7.9975H16.5M1.5 7.9975H9.75M9.75 13.2475H16.5M1.5 13.2475H5.25M7.875 2.6875C7.87151 3.18934 7.67468 3.67051 7.32545 4.03092C6.97622 4.39132 6.50148 4.60321 6 4.6225C5.49852 4.60321 5.02378 4.39132 4.67455 4.03092C4.32532 3.67051 4.12849 3.18934 4.125 2.6875C4.125 2.19022 4.32254 1.71331 4.67417 1.36167C5.02581 1.01004 5.50272 0.8125 6 0.8125C6.49728 0.8125 6.97419 1.01004 7.32583 1.36167C7.67746 1.71331 7.875 2.19022 7.875 2.6875ZM13.875 7.9375C13.875 8.43478 13.6775 8.91169 13.3258 9.26333C12.9742 9.61496 12.4973 9.8125 12 9.8125C11.5027 9.8125 11.0258 9.61496 10.6742 9.26333C10.3225 8.91169 10.125 8.43478 10.125 7.9375C10.125 7.44022 10.3225 6.96331 10.6742 6.61168C11.0258 6.26004 11.5027 6.0625 12 6.0625C12.4973 6.0625 12.9742 6.26004 13.3258 6.61168C13.6775 6.96331 13.875 7.44022 13.875 7.9375ZM9.375 13.1875C9.37151 13.6893 9.17468 14.1705 8.82545 14.5309C8.47622 14.8913 8.00148 15.1032 7.5 15.1225C6.99852 15.1032 6.52378 14.8913 6.17455 14.5309C5.82532 14.1705 5.62849 13.6893 5.625 13.1875C5.625 12.6902 5.82254 12.2133 6.17417 11.8617C6.52581 11.51 7.00272 11.3125 7.5 11.3125C7.99728 11.3125 8.47419 11.51 8.82583 11.8617C9.17746 12.2133 9.375 12.6902 9.375 13.1875Z",
    stroke: "#7043FF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildSequenceStrong);
export default __webpack_public_path__ + "static/media/build_sequence_strong.695d55e3c05039e3620e94636f8b39f3.svg";
export { ForwardRef as ReactComponent };